<script setup lang="ts">
import { pinia } from '@/stores'
import { useRouterStore } from '@/stores/router'
import { getLimitDate, getTimeLeft, removeLimitDate } from '@/utils/limit-date'
import { ref, onMounted, onUnmounted, watch, onBeforeMount } from 'vue'

const { push } = useRouterStore(pinia)

const timeLeft = ref<number>(0)

const minutes = ref<number>(0)
const seconds = ref<number>(0)

let interval: null | ReturnType<typeof setInterval> = null

watch(timeLeft, (newValue) => {
  minutes.value = Math.floor(newValue / 60)
  seconds.value = newValue % 60
})

const countDown = () => {
  const _limitDate = getLimitDate()
  if (_limitDate && timeLeft.value > 0) {
    timeLeft.value = getTimeLeft(_limitDate)
  } else {
    removeLimitDate()
    push('timesup')
  }
}

const formatSeconds = (seconds: number | undefined) => {
  return String(seconds).padStart(2, '0')
}

onMounted(() => {
  interval = setInterval(countDown, 1000)
})

onBeforeMount(() => {
  const _limitDate = getLimitDate()
  if (_limitDate) {
    const _timeLeft = getTimeLeft(_limitDate)

    if (_timeLeft > 0) {
      timeLeft.value = _timeLeft
    } else {
      removeLimitDate()
      push('address')
    }
  }
})

onUnmounted(() => {
  if (interval) {
    clearInterval(interval)
  }
})
</script>

<template>
  <div class="text-center mb-10">
    <h2 class="text-5xl">BETALING</h2>
    <div class="flex justify-center">
      <div class="mr-5">
        <p class="text-5xl">{{ minutes }}</p>
        <p>MINUTEN</p>
      </div>
      <div>
        <p class="text-5xl">{{ formatSeconds(seconds) }}</p>
        <p>SECONDEN</p>
      </div>
    </div>
  </div>
</template>
